import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Truck, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

export default function Services() {
  const [services, setServices] = useState([]);
  const [areas, setAreas] = useState([]);

  useEffect(() => {
    api.get("/services?active_only=true").then((r) => setServices(r.data)).catch(() => {});
    api.get("/service-areas?active_only=true").then((r) => setAreas(r.data)).catch(() => {});
  }, []);

  return (
    <div className="bg-[var(--lt-bg)]">
      <section className="relative py-24 border-b border-[var(--lt-border)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="font-mono-lt text-xs uppercase tracking-[0.3em] text-[var(--lt-accent-bright)] mb-3">// Transportation Services</div>
          <h1 className="font-display font-black text-5xl md:text-6xl text-white uppercase leading-none">Freight Transportation.</h1>
          <p className="text-slate-400 mt-5 max-w-2xl text-lg">Lucas Trans Inc. provides asset-based motor carrier services for shippers who need consistent, professional transportation.</p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 gap-6">
          {services.map((s) => (
            <div key={s.id} className="bg-[var(--lt-panel)] border border-[var(--lt-border)] p-8 hover:border-[var(--lt-accent)] transition-colors" data-testid={`service-${s.slug}`}>
              <div className="h-11 w-11 bg-[var(--lt-accent)] flex items-center justify-center mb-5"><Truck className="h-5 w-5 text-white" /></div>
              <h2 className="font-display font-black text-2xl md:text-3xl text-white uppercase">{s.name}</h2>
              <p className="text-slate-400 mt-3 leading-relaxed">{s.description}</p>
              <Link to="/quote"><Button className="mt-6 bg-[var(--lt-accent)] hover:bg-[var(--lt-accent-hover)] text-white h-11 px-6 rounded-xl font-head uppercase tracking-widest text-xs">Request Quote <ArrowRight className="ml-2 h-4 w-4" /></Button></Link>
            </div>
          ))}
        </div>
      </section>

      <section className="py-20 bg-[var(--lt-panel)] border-t border-[var(--lt-border)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="font-mono-lt text-xs uppercase tracking-[0.3em] text-[var(--lt-accent-bright)] mb-3">// Service Area</div>
          <h2 className="font-display font-black text-3xl md:text-4xl text-white uppercase mb-8">Where We Run</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {areas.map((a) => (
              <div key={a.id} className="bg-[var(--lt-bg)] border border-[var(--lt-border)] p-6" data-testid={`area-${a.id}`}>
                <div className="text-xs font-mono-lt uppercase tracking-[0.25em] text-[var(--lt-accent-bright)]">{a.kind}</div>
                <div className="font-head font-bold text-xl text-white uppercase mt-1">{a.name}</div>
                {a.notes && <p className="text-sm text-slate-400 mt-2">{a.notes}</p>}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
